module.exports = __webpack_public_path__ + "static/1-e6568cd1f5c0f2e519a184865823674c.jpg";